import { Typography } from '@mui/material';
import ImagePageNotFound from '@assets/images/undraw_page_not_found.svg';
import PageContent from '@templates/PageContent';
import useT from '@hooks/useT';

function Image404() {
  return (
    <div style={{ display: 'flex' }}>
      <img
        src={ImagePageNotFound}
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '4px',
        }}
        alt="404 Not found"
      />
    </div>);
}

function NotFound({ withContainer }: { withContainer?: boolean }) {
  const { t } = useT('errors');
  const title = t('components.pageNotFound');
  return (
    <PageContent header={withContainer ? title : undefined}>
      {!withContainer && <Typography variant="h5" mt={4} textAlign="center">{title}</Typography>}
      <Image404 />
    </PageContent>);
}

export default NotFound;
